import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="fulfillment-input"
export default class extends Controller {
  static targets = ["shippingPriceField"];

  toggle(event) {
    if (event.target.checked) {
      this.shippingPriceFieldTarget.classList.remove("hidden");
    } else {
      this.shippingPriceFieldTarget.classList.add("hidden");
    }
  }
}
